import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import categories from './categories'
import tags from './tags'
/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:21
* @route 'https://org.proexpert.app/org/taxonomy'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/taxonomy',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:21
* @route 'https://org.proexpert.app/org/taxonomy'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:21
* @route 'https://org.proexpert.app/org/taxonomy'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:21
* @route 'https://org.proexpert.app/org/taxonomy'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:21
* @route 'https://org.proexpert.app/org/taxonomy'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:21
* @route 'https://org.proexpert.app/org/taxonomy'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgTaxonomyController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgTaxonomyController.php:21
* @route 'https://org.proexpert.app/org/taxonomy'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

const taxonomy = {
    index: Object.assign(index, index),
    categories: Object.assign(categories, categories),
    tags: Object.assign(tags, tags),
}

export default taxonomy